module.exports = __webpack_public_path__ + "img/test.1d3004b0.jpg";